import classNames from 'classnames';

export default function GraphLink({
  onClick,
  className,
}: {
  onClick?: () => void;
  className?: string;
}) {
  return (
    <div
      className={classNames('group/svg', className)}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      <svg
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        viewBox="0 0 1402 1012"
        className={classNames('w-full', onClick ? 'cursor-pointer' : undefined)}
      >
        <path
          className={classNames(
            'fill-gray-700',
            onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
          )}
          d="M1034.3,21.3c-48.1,0-87.3,39.1-87.3,87.3c0,15.1,3.8,29.2,10.6,41.6l-143,143c-19.7-15.3-44.4-24.6-71.2-24.6
	c-26.9,0-51.5,9.2-71.2,24.6L560.6,181.6c5.1-8.7,8.2-18.6,8.2-29.4c0-32.1-26.1-58.2-58.2-58.2s-58.2,26.1-58.2,58.2
	s26.1,58.2,58.2,58.2c10.8,0,20.7-3.1,29.4-8.2l111.5,111.5c-15.3,19.7-24.6,44.4-24.6,71.2c0,26.9,9.2,51.5,24.6,71.2L467.4,640.4
	c-15.5-14.1-36-22.7-58.5-22.7c-48.1,0-87.3,39.1-87.3,87.3c0,48.1,39.1,87.3,87.3,87.3s87.3-39.1,87.3-87.3
	c0-15.1-3.8-29.2-10.6-41.6l186.6-186.6c16.1,12.5,35.5,20.9,56.7,23.5v147.8c-41.2,7-72.7,42.8-72.7,86c0,48.1,39.1,87.3,87.3,87.3
	s87.3-39.1,87.3-87.3c0-43.2-31.5-79-72.7-86V500.3c21.2-2.7,40.6-11,56.7-23.5l111.5,111.5c-5.1,8.7-8.3,18.6-8.3,29.4
	c0,32.1,26.1,58.2,58.2,58.2s58.2-26.1,58.2-58.2s-26.1-58.2-58.2-58.2c-10.8,0-20.7,3.1-29.4,8.2L835.2,456.2
	c15.3-19.7,24.6-44.4,24.6-71.2c0-26.9-9.2-51.5-24.6-71.2l140.6-140.6c15.5,14.1,36,22.7,58.5,22.7c48.1,0,87.3-39.1,87.3-87.3
	S1082.4,21.3,1034.3,21.3z M481.6,152.2c0-16,13-29.1,29.1-29.1c16,0,29.1,13,29.1,29.1s-13,29.1-29.1,29.1
	C494.6,181.3,481.6,168.3,481.6,152.2z M408.8,763.1c-32.1,0-58.2-26.1-58.2-58.2c0-32.1,26.1-58.2,58.2-58.2s58.2,26.1,58.2,58.2
	C467,737,440.9,763.1,408.8,763.1z M801.6,734c0,32.1-26.1,58.2-58.2,58.2s-58.2-26.1-58.2-58.2s26.1-58.2,58.2-58.2
	S801.6,701.9,801.6,734z M743.4,472.2c-48.1,0-87.3-39.1-87.3-87.3s39.1-87.3,87.3-87.3s87.3,39.1,87.3,87.3
	S791.5,472.2,743.4,472.2z M1005.2,617.7c0,16-13,29.1-29.1,29.1s-29.1-13-29.1-29.1s13-29.1,29.1-29.1S1005.2,601.6,1005.2,617.7z
	 M1034.3,166.8c-32.1,0-58.2-26.1-58.2-58.2s26.1-58.2,58.2-58.2c32.1,0,58.2,26.1,58.2,58.2S1066.4,166.8,1034.3,166.8z"
        />
        <g>
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M296.5,963.5c-6.9,6.3-15.7,9.4-26.4,9.4c-13.2,0-23.7-4.2-31.2-12.8c-7.6-8.5-11.4-20.2-11.4-35.1
		c0-16.1,4.3-28.5,12.9-37.2c7.5-7.6,17-11.4,28.6-11.4c15.5,0,26.8,5.1,34,15.2c4,5.7,6.1,11.4,6.4,17.2h-19.2
		c-1.2-4.4-2.9-7.8-4.8-10c-3.5-4-8.7-6-15.6-6c-7,0-12.5,2.8-16.6,8.5c-4,5.6-6.1,13.6-6.1,24c0,10.3,2.1,18.1,6.4,23.2
		c4.3,5.1,9.7,7.7,16.3,7.7c6.8,0,11.9-2.2,15.4-6.6c2-2.4,3.6-5.9,4.9-10.7h19.1C307.6,949.1,303.3,957.2,296.5,963.5z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M322.9,878.3h17.8v92.1h-17.8V878.3z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M376.4,877.7v16.4h-18.1v-16.4H376.4z M376.4,902.3v68.1h-18.1v-68.1H376.4z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M484.7,878.3h19.6l-25.9,92.1h-18.4l-11.1-53.9l-3.2-17.8l-3.2,17.8l-11.1,53.9h-17.9l-26.1-92.1h20.4
		l12.2,52.8l2.6,14.7l2.7-14.4l10.4-53.1h20.3l10.9,52.8l2.8,14.7l2.8-14.1L484.7,878.3z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M512.3,909.7c4.7-6,12.8-9,24.2-9c7.5,0,14.1,1.5,19.9,4.4c5.8,3,8.7,8.5,8.7,16.8v31.2c0,2.2,0,4.8,0.1,7.9
		c0.1,2.3,0.5,3.9,1.1,4.8c0.6,0.8,1.5,1.5,2.6,2.1v2.6h-19.4c-0.5-1.4-0.9-2.7-1.1-3.9c-0.2-1.2-0.4-2.6-0.5-4.1
		c-2.5,2.7-5.3,4.9-8.5,6.8c-3.8,2.2-8.2,3.3-13,3.3c-6.2,0-11.3-1.8-15.3-5.3c-4-3.5-6-8.5-6-15c0-8.4,3.2-14.4,9.7-18.2
		c3.5-2,8.8-3.5,15.6-4.4l6.1-0.8c3.3-0.4,5.6-0.9,7.1-1.6c2.5-1.1,3.8-2.8,3.8-5.1c0-2.8-1-4.7-2.9-5.8s-4.8-1.6-8.5-1.6
		c-4.2,0-7.2,1-8.9,3.1c-1.2,1.5-2.1,3.6-2.5,6.2h-17.2C507.7,918.4,509.3,913.5,512.3,909.7z M525.5,957.5c1.7,1.4,3.7,2.1,6.1,2.1
		c3.8,0,7.4-1.1,10.6-3.4c3.2-2.2,4.9-6.4,5-12.3v-6.6c-1.1,0.7-2.3,1.3-3.4,1.7c-1.1,0.4-2.7,0.8-4.7,1.2l-4,0.8
		c-3.8,0.7-6.4,1.5-8.1,2.4c-2.8,1.6-4.1,4.1-4.1,7.6C523,954,523.8,956.2,525.5,957.5z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M647.4,963.5c-6.9,6.3-15.7,9.4-26.4,9.4c-13.2,0-23.7-4.2-31.2-12.8c-7.6-8.5-11.4-20.2-11.4-35.1
		c0-16.1,4.3-28.5,12.9-37.2c7.5-7.6,17-11.4,28.6-11.4c15.5,0,26.8,5.1,34,15.2c4,5.7,6.1,11.4,6.4,17.2H641
		c-1.2-4.4-2.9-7.8-4.8-10c-3.5-4-8.7-6-15.6-6c-7,0-12.5,2.8-16.6,8.5c-4,5.6-6.1,13.6-6.1,24c0,10.3,2.1,18.1,6.4,23.2
		c4.3,5.1,9.7,7.7,16.3,7.7c6.8,0,11.9-2.2,15.4-6.6c2-2.4,3.6-5.9,4.9-10.7h19.1C658.4,949.1,654.2,957.2,647.4,963.5z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M774.5,930.2h-44.8v23.7h51v16.6h-69.8v-92.1h67.6v16.3h-48.8v19.6h44.8V930.2z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M855,970.4h-22.2L821,950l-11.8,20.4h-21.6l23.2-34.5l-22.2-33.5h21.8l11.4,19.8l11.1-19.8h21.2l-22.4,33.2
		L855,970.4z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M922.5,909.6c5.5,5.9,8.2,14.5,8.2,25.9c0,12-2.7,21.1-8.1,27.4c-5.4,6.3-12.3,9.4-20.8,9.4
		c-5.4,0-9.9-1.4-13.5-4.1c-2-1.5-3.9-3.7-5.8-6.6v35.5H865v-94.9H882v10.1c1.9-3,4-5.3,6.1-7c4-3,8.7-4.6,14.1-4.6
		C910.3,900.8,917,903.7,922.5,909.6z M912.4,936.4c0-5.2-1.2-9.9-3.6-13.9c-2.4-4-6.3-6.1-11.7-6.1c-6.5,0-10.9,3.1-13.3,9.2
		c-1.2,3.2-1.9,7.4-1.9,12.4c0,7.9,2.1,13.5,6.3,16.7c2.5,1.9,5.5,2.8,8.9,2.8c5,0,8.7-1.9,11.3-5.8
		C911.1,947.8,912.4,942.7,912.4,936.4z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M944,878.3h17.8v92.1H944V878.3z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M1036,910.9c5.8,7.2,8.6,15.7,8.6,25.6c0,10-2.9,18.6-8.6,25.7c-5.8,7.1-14.5,10.7-26.2,10.7
		c-11.7,0-20.4-3.6-26.2-10.7c-5.8-7.1-8.6-15.7-8.6-25.7c0-9.8,2.9-18.4,8.6-25.6c5.8-7.2,14.5-10.8,26.2-10.8
		C1021.6,900.1,1030.3,903.7,1036,910.9z M1009.8,915.2c-5.2,0-9.2,1.8-12,5.5s-4.2,8.9-4.2,15.8c0,6.8,1.4,12.1,4.2,15.8
		c2.8,3.7,6.8,5.6,12,5.6c5.2,0,9.2-1.9,12-5.6c2.8-3.7,4.2-9,4.2-15.8c0-6.8-1.4-12.1-4.2-15.8C1019,917,1015,915.2,1009.8,915.2z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M1091.7,918.7c-7.2,0-12,2.3-14.4,7c-1.4,2.6-2.1,6.7-2.1,12.1v32.6h-17.9v-68.1h17v11.9
		c2.8-4.5,5.1-7.6,7.2-9.3c3.3-2.8,7.7-4.2,13-4.2c0.3,0,0.6,0,0.8,0c0.2,0,0.7,0.1,1.5,0.1V919c-1.1-0.1-2.1-0.2-3-0.2
		C1092.9,918.8,1092.2,918.7,1091.7,918.7z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M1165.5,950.4c-0.5,4-2.6,8.1-6.3,12.3c-5.8,6.6-14,9.9-24.5,9.9c-8.7,0-16.3-2.8-22.9-8.4
		c-6.6-5.6-9.9-14.7-9.9-27.2c0-11.8,3-20.8,9-27.1c6-6.3,13.7-9.4,23.3-9.4c5.7,0,10.8,1.1,15.3,3.2c4.5,2.1,8.3,5.5,11.2,10.1
		c2.7,4,4.4,8.7,5.2,14.1c0.5,3.1,0.6,7.6,0.6,13.5h-46.6c0.2,6.8,2.4,11.6,6.4,14.4c2.5,1.7,5.4,2.6,8.9,2.6c3.7,0,6.6-1,8.9-3.1
		c1.2-1.1,2.4-2.7,3.3-4.7H1165.5z M1147.9,929.5c-0.3-4.7-1.7-8.3-4.3-10.7s-5.7-3.7-9.5-3.7c-4.1,0-7.3,1.3-9.6,3.9
		c-2.3,2.6-3.7,6.1-4.3,10.5H1147.9z"
          />
          <path
            className={classNames(
              'fill-gray-700',
              onClick ? 'group-hover/svg:fill-cliwac-orange' : undefined
            )}
            d="M1212.7,918.7c-7.2,0-12,2.3-14.4,7c-1.4,2.6-2.1,6.7-2.1,12.1v32.6h-17.9v-68.1h17v11.9
		c2.8-4.5,5.1-7.6,7.2-9.3c3.3-2.8,7.7-4.2,13-4.2c0.3,0,0.6,0,0.8,0c0.2,0,0.7,0.1,1.5,0.1V919c-1.1-0.1-2.1-0.2-3-0.2
		C1213.9,918.8,1213.2,918.7,1212.7,918.7z"
          />
        </g>
      </svg>
    </div>
  );
}
